import React from 'react';
import { FiDownload, FiFileText, FiEye } from 'react-icons/fi';
import { toast } from 'react-toastify';

import { useAuth } from '../../contexts/AuthContext';
import { trainingService } from '../../services/aiService';

// Hilfsfunktion für Dateinamen
function cleanFilename(filename) {
  return filename
    .replace(/Ã¤/g, 'ä')
    .replace(/Ã¶/g, 'ö')
    .replace(/Ã¼/g, 'ü')
    .replace(/ÃŸ/g, 'ß')
    .replace(/Ã„/g, 'Ä')
    .replace(/Ã–/g, 'Ö')
    .replace(/Ãœ/g, 'Ü');
}

function SourceList({ sources, onViewDocument }) {
  const { isDarkMode } = useAuth();

  const handleDownload = async (documentId, filename) => {
    toast.info(`Download für "${cleanFilename(filename)}" wird gestartet...`);
    try {
      await trainingService.downloadDocument(documentId);
    } catch (error) {
      toast.error(`Download fehlgeschlagen: ${error.message}`);
      console.error('Download error:', error);
    }
  };

  return (
    <div
      className={`${isDarkMode ? 'bg-gray-800 border-gray-700' : 'bg-white border-gray-200'} border rounded-lg p-3 h-full flex flex-col`}
    >
      <h3
        className={`text-sm font-semibold mb-2 flex items-center gap-2 flex-shrink-0 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}
      >
        <FiFileText className="text-blue-400" />
        Durchsuchte Dokumente
        {sources.length > 0 && (
          <span className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>
            ({sources.length})
          </span>
        )}
      </h3>
      <div className="overflow-y-auto flex-grow">
        {sources.length > 0 ? (
          <ul className="space-y-1">
            {sources.map((source) => (
              <li
                key={source.id}
                className={`flex items-center justify-between p-2 rounded-md ${isDarkMode ? 'bg-gray-700/50' : 'bg-gray-50'}`}
              >
                <div className="flex items-center gap-2 flex-1 min-w-0">
                  <FiFileText className="text-blue-400 flex-shrink-0" size={14} />
                  <span
                    className={`text-xs truncate ${isDarkMode ? 'text-gray-200' : 'text-gray-700'}`}
                    title={cleanFilename(source.filename)}
                  >
                    {cleanFilename(source.filename)}
                  </span>
                </div>
                <div className="flex items-center gap-1 flex-shrink-0">
                  <button
                    onClick={() => onViewDocument(source.id, source.filename)}
                    className={`p-1 ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`}
                    title="Dokument anzeigen"
                  >
                    <FiEye size={14} />
                  </button>
                  <button
                    onClick={() => handleDownload(source.id, source.filename)}
                    className={`p-1 ${isDarkMode ? 'text-gray-400 hover:text-white' : 'text-gray-500 hover:text-gray-700'}`}
                    title="Dokument herunterladen"
                  >
                    <FiDownload size={14} />
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div
            className={`text-center h-full flex flex-col justify-center items-center ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}
          >
            <FiFileText className="text-2xl mb-2 opacity-50" />
            <p className="text-xs">Keine Dokumente verwendet</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default SourceList;
